import { useCallback, useEffect, useState } from "react";
import api from "../../api";

export default function useAnalyticsFilters({ courseId, academicCourseId } = {}) {
  const [courses, setCourses] = useState([]);
  const [academicCourses, setAcademicCourses] = useState([]);
  const [plans, setPlans] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      const params = {};
      if (courseId) params.course_id = courseId;
      if (academicCourseId) params.academic_course_id = academicCourseId;
      const res = await api.get("admin/analytics/filters", { params });
      const d = res.data?.data || res.data || {};
      setCourses(d.courses || []);
      setAcademicCourses(d.academic_courses || []);
      setPlans(d.plans || []);
      setLocations(d.locations || []);
    } catch {
      setCourses([]);
      setAcademicCourses([]);
      setPlans([]);
      setLocations([]);
    } finally {
      setLoading(false);
    }
  }, [courseId, academicCourseId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { courses, academicCourses, plans, locations, loading, reload };
}
